import api from "../../../services/api";

const APIS = {
  DASHBOARD_DATA: "/DashBoard/admindashboard",
};

export const getDashboardData = async (params = {}) => {
  try {
    const response = await api.get(APIS.DASHBOARD_DATA, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};
